import { giphyCharcoal } from '@giphy/colors'
import { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { CreationToolSelectListOption } from '../types'
import CreationToolGradient from '../types/gradient'
import CreationToolUIAnimation from '../types/ui-animation'
import { ToolButton } from './buttons'
import DropdownComponent from './dropdown'

const Dropdown = styled(DropdownComponent)`
    white-space: nowrap;
`

const SelectItem = styled(ToolButton)`
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    width: 100%;

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }
`

const Checkmark = styled.i<{ colors: string[]; active?: boolean }>`
    background: ${({ colors }) => `linear-gradient(45deg, ${colors[0]} 0%, ${colors[1]} 100%)`};
    border-radius: 50%;
    color: #000;
    display: inline-block;
    flex-shrink: 0;
    font-weight: normal;
    font-size: 10px;
    height: 16px;
    line-height: 18px;
    margin: 8px 0 0 10px;
    text-align: center;
    vertical-align: top;
    visibility: hidden;
    width: 16px;

    ${({ active }) =>
        active &&
        css`
            ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
            visibility: visible;
        `}
`

const AdditionalOptions = styled.div`
    border-top: 1px solid ${giphyCharcoal};
    font-size: 16px;
    line-height: 32px;
    margin-top: 5px;
    padding: 5px 10px 0;
`

type Props = {
    className?: string
    children?: ReactNode
    value?: string
    options: CreationToolSelectListOption[]
    popUpColor?: string
    onChange: (value: string) => void
}

const CreationToolsSelectList = ({ className, children, value, options, popUpColor, onChange }: Props) => {
    const activeOption = value ? options.find((option) => option.value === value) : null
    const activeIndex = activeOption ? options.indexOf(activeOption) : -1

    return (
        <Dropdown
            {...{
                className,
                popUpColor,
                preview: activeOption?.preview,
                label: activeOption?.label || 'None',
            }}
        >
            {options.map((option, i) => (
                <SelectItem
                    key={`ctselectlistitem${i}`}
                    style={typeof option.label === 'string' && i === activeIndex ? { fontWeight: 'bold' } : {}}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                    <Checkmark
                        className="ss-check"
                        colors={CreationToolGradient.colors(CreationToolGradient.IndigoBlue)}
                        active={i === activeIndex}
                    />
                </SelectItem>
            ))}
            {children && (
                <AdditionalOptions style={options.length < 1 ? { borderTop: 'none', marginTop: 0, paddingTop: 0 } : {}}>
                    {children}
                </AdditionalOptions>
            )}
        </Dropdown>
    )
}

export default CreationToolsSelectList
